import React from 'react';
import { Roles } from '../../../constants/Roles';
import Storage from '../../../services/Storage';
import './index.css';

export const SingleCountBlock = ({
  heading,
  count,
  heightDeduct,
  countColor,
  numberClick,
  marginTop,
  handleParentClick,
}) => {

  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role: '';

  return (
    <div
      id='singleCountBlock'
      className={`${roleName !== Roles.TM_NAME ? 'dashboardTitleArrow' : ''} ${heightDeduct === true ? 'heightDeduction' : ''}`}
      onClick={roleName !== Roles.TM_NAME ? handleParentClick : undefined}
      style={{ cursor: roleName !== Roles.TM_NAME ? 'pointer' : 'auto' }}
    >
      <h6 className={`${marginTop ? 'marginTopHeading' : ''}`}>{heading}</h6>
      <div
        className={`singleCountCard ${
          heightDeduct === true ? 'marginTopHeading' : ''
        }`}
        onClick={numberClick}
      >
        <div className='signelInnerCardText'>
          <span
            className={`number ${
              heightDeduct === true ? 'marginTopHeading' : ''
            } ${countColor}`}
          >
            {count}
          </span>
        </div>
      </div>
    </div>
  );
};
